import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
export class SharedService {  
  randomString = new BehaviorSubject<string>('');
  
    isEnglish(lang: string){
    if(lang === "English" || lang == "en") {
      return true;
    }
    return false;
  }

  isFrench(lang: string){
    if(lang === "French") {
      return true;
    }
    return false;
  }
  }